import { Component } from '@angular/core';

@Component({
  selector: 'opus-reports-landing',
  templateUrl: './reports-landing.component.html',
})
export class ReportsLandingComponent { }
